import React, { useEffect, useState } from 'react';
import { DialogUI, ButtonUI, InputUI, DatePickerUI } from '../../Interface';
import { Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';

const defaultBatch = {
  id: null,
  batchSn: '',
  lot: '',
  supplierId: '',
  expDate: '',
  mnfDate: '',
  batchAttribute1: '',
  batchAttribute2: '',
  comment: '',
  price: '',
  other: '',
  quantity: '',
};

const ProductionBatchDialog = ({ open, onClose, batchList = [], onSave, defaultBatchSn = '' }) => {
  const [row, setRow] = useState({ ...defaultBatch, id: uuidv4(), batchSn: defaultBatchSn ?? '' });

  useEffect(() => {
    if (!open) return;

    const source = batchList.length ? { ...batchList[0] } : { ...defaultBatch };
    const next = {
      ...source,
      id: source.id ?? uuidv4(),
      batchSn: source.batchSn || defaultBatchSn || '',
    };

    setRow(next);
  }, [open, batchList, defaultBatchSn]);

  const handleRowChange = (field, value) => {
    setRow((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    onSave([row]);
    onClose();
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent={'Sarzs szerkesztés'} maxWidth="md" fullWidth>
      <Box sx={{ p: 2 }}>
        <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 2, position: 'relative' }}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
            <InputUI
              label="Sarzs"
              value={row.batchSn}
              onChange={(e) => handleRowChange('batchSn', e.target.value)}
              size="small"
              sx={{ minWidth: 120, flex: 2 }}
              variant="standard"
            />
            <InputUI
              label="LOT"
              value={row.lot}
              onChange={(e) => handleRowChange('lot', e.target.value)}
              size="small"
              sx={{ minWidth: 100, flex: 1 }}
              variant="standard"
            />
            <DatePickerUI
              label="Lejárat"
              type="date"
              value={row.expDate ? dayjs(row.expDate) : null}
              onChange={(e) => handleRowChange('expDate', e)}
              size="small"
              sx={{ minWidth: 120, flex: 1 }}
              variant="standard"
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
            <InputUI
              label="Attribútum 1"
              value={row.batchAttribute1}
              onChange={(e) => handleRowChange('batchAttribute1', e.target.value)}
              size="small"
              sx={{ minWidth: 120, flex: 1 }}
              variant="standard"
            />
            <InputUI
              label="Attribútum 2"
              value={row.batchAttribute2}
              onChange={(e) => handleRowChange('batchAttribute2', e.target.value)}
              size="small"
              sx={{ minWidth: 120, flex: 1 }}
              variant="standard"
            />
            <InputUI
              label="Egyéb"
              value={row.other}
              onChange={(e) => handleRowChange('other', e.target.value)}
              size="small"
              sx={{ minWidth: 120, flex: 1 }}
              variant="standard"
            />
            <InputUI
              label="Megjegyzés"
              value={row.comment}
              onChange={(e) => handleRowChange('comment', e.target.value)}
              size="small"
              sx={{ minWidth: 120, flex: 2 }}
              variant="standard"
            />
          </Box>
        </Box>
      </Box>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
        <ButtonUI text="Mentés" className="bg-success" onClick={handleSave} />
        <ButtonUI text="Mégse" color="blue-gray" variant="gradient" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default ProductionBatchDialog;
